import type { ApiResponse } from 'apisauce'
import type { ResAllType } from '../../Types/Api/All'
import type {
  CmsAdminUser,
  CmsAdminUserMainInfo,
  CmsAdminUserOKRes,
  CreateCmsAdminUserRequest,
} from '../../Types/Api/CmsAdmin'
import type { ErrorRes } from '../../Types/Api/Error'
import type { FilteringConditions } from '../../Types/Api/Lead'
import { api } from './API'
import { requireAuth } from './Auth'

//
// CMS Admin
//

export const searchCmsAdmin = async (page: number) => {
  return await requireAuth<ResAllType<CmsAdminUser>>(
    api.get('cms_admins', { page }),
  )
}

export const getCmsAdmins = async () => {
  return await requireAuth<any>(api.get('cms_admins/form'))
}

export const createCmsAdmin = async (values: CreateCmsAdminUserRequest) => {
  return await requireAuth<CmsAdminUser>(api.post('cms_admins', values))
}

export const updateCmsAdmin = async (values: {
  role_id: number
  id: number
  is_notifiable: boolean
}) => {
  return await requireAuth<CmsAdminUserOKRes>(
    api.patch(`cms_admins/${values.id}`, values),
  )
}

export const deleteCmsAdmin = async (id: number) => {
  return await requireAuth<CmsAdminUserOKRes>(api.delete(`cms_admins/${id}`))
}

export const findCmsAdmin = async (id: number) => {
  return requireAuth<CmsAdminUser>(api.get(`cms_admins/${id}`))
}

export const invite = (emails: string[]) => {
  return requireAuth<{ errors: any }>(
    api.post('cms_admin/invites_store', { emails }),
  )
}

export const findInviteCmsAdmin = (
  id: string,
): Promise<ApiResponse<CmsAdminUserMainInfo | ErrorRes>> => {
  return api.get(`cms_admin/invites_show/${id}`)
}

export const sendPasswordResetEmail = async (email: string) => {
  return requireAuth<CmsAdminUserMainInfo>(
    api.post('cms_admin/password/email', { email }),
  )
}

export const findPasswordResetCmsAdmin = (
  id: string,
): Promise<ApiResponse<CmsAdminUserMainInfo | ErrorRes>> => {
  return api.get(`cms_admin/password/reset/${id}`)
}

export const updateOtherCmsAdmin = async (values) => {
  return await requireAuth(api.patch('cms_admins', values))
}

export const findAllCmsAdmins = async (domain: string) => {
  const res = await requireAuth(api.get('cms_admins'))

  if (res.ok) {
    return res.data
  }

  return []
}

export const setDisplaySetting = async (values: string[], id: number) => {
  return await requireAuth(
    api.post('cms_admin/display_setting', {
      display_field_orders: values,
      id: id,
    }),
  )
}

export const setLeadDetailDisplaySettings = async (
  values: string[],
  id: number,
) => {
  return await requireAuth(
    api.post('cms_admin/lead_detail_display_settings', {
      lead_detail_display_settings: values,
      id: id,
    }),
  )
}

export const setFilteringConditions = async (
  filtering_conditions: FilteringConditions[] | null,
  id: number,
) => {
  return await requireAuth(
    api.post('cms_admin/filtering_conditions', {
      filtering_conditions,
      id: id,
    }),
  )
}
